import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ProgressBarModule } from 'primeng/progressbar';

import { NavService } from '@services/nav.service';

@Component({
  selector: 'bk-loading-bar',
  imports: [ProgressBarModule],
  templateUrl: './loading-bar.component.html',
  styleUrl: './loading-bar.component.scss',
})
export class LoadingBarComponent {
  navService = inject(NavService);
  showLoadingBar = toSignal(this.navService.showLoadingBar$);
}
